import React, { useState } from "react";
import { Button, Typography, Grid, Box } from '@material-ui/core';
import translate from "../i18n/Translator";
import { User, SafeToNotifyRequest } from '../model/User';
import DialogPopup from "../components/DialogPopup";
import ValidatedInput from "../components/ValidatedInput";
import { ErrorSnackbar } from "../components/Snackbars";
import SimpleSwitch from '../components/SimpleSwitch';
import { safeToNotify } from "../api/SupportAPI";

interface EnableEmailPopupProps {
    user: User;
    providerId?: string;
    onClose(): any;
    onSuccess(): any;
}

export default function EnableEmailPopup(props: EnableEmailPopupProps) {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [request, setRequest] = useState<SafeToNotifyRequest>({ user_id: props.user.id, safe_to_notify: props.user.safe_to_notify, provider_id: props.providerId } as SafeToNotifyRequest);
    const [error, setError] = useState<string>();
    const [valid, setValid] = useState<boolean>(false);

    const enableEmail = () => {
        setSubmitting(true);
        safeToNotify(request)
            .then(() => {
                setSubmitting(false);
                props.onSuccess();
            })
            .catch((error) => {
                setSubmitting(false);
                setError(error.message);
            });
    };

    const onClosedSnackbar = () => {
        setError(undefined);
    };

    const hasChanged = (name: string, value: string) => {
        setRequest({ ...request, comments: value });
    };

    const onChangeSwitch = (name: string, checked: boolean) => {
        setRequest({ ...request, safe_to_notify: checked });
    };

    const onValidate = () => {
        setSubmitting(true);
        if (!!request.comments) {
            setValid(true);
            enableEmail();
        } else {
            setSubmitting(false);
        }
    };

    return (
        <DialogPopup open
            title={translate("users.enable_email_popup.title") as string}
            subTitle={props.user.email}
            disable={submitting}
            closeText={translate("buttons.cancel") as string}
            onClose={props.onClose}
            closeColor="default"
            maxWidth="sm"
            button={
                <Button onClick={onValidate} variant="contained" color="primary" disabled={submitting}>
                    {translate("buttons.save")}
                </Button>}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body2">
                        {translate("users.enable_email_popup.message")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SimpleSwitch
                        value="true"
                        label={translate("users.enable_email_popup.enable_email") as string}
                        checked={request.safe_to_notify}
                        onChanged={onChangeSwitch}
                        placement="end"
                    />
                </Grid>

                <Grid item xs={12}>
                    <ValidatedInput id="comments" name="comments" disabled={submitting}
                        errorMessage={valid ? "" : translate("validations.required") as string}
                        value={request.comments}
                        required={true}
                        type="text"
                        margin={"dense"}
                        rows={5}
                        label={translate("users.enable_email_popup.comments") as string}
                        onValueChanged={hasChanged} />
                </Grid>
            </Grid>
            <ErrorSnackbar message={error} onClose={onClosedSnackbar} />
        </DialogPopup>
    );

}